import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash-es';
import { showAlert} from '../../../../../Assests/Utility';
import { AppConstant } from '../../../../../Assests/AppConstant'
import { sagaActions } from '../../../../../../sagas/sagaActions';
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../Components/DatePicker/DatePicker.css"
import { CustomPaginationSS } from '../../../../Common/CustomPaginationSS/CustomPaginationSS';
import { getRemoteConfigSelector } from '../../../../../../redux/reducers/reducerSlices/RemoteConfigReducer';
import DrilldownTableSS from '../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTableSS';
import { toast } from 'react-toastify';
import "./SPRODockMapping.css";
import CustomButtonSS from '../../../../Common/CustomButton/CustomButtonSS';
import Popup from '../../../../Common/Popup/Popup';
import { CustomDynamicForm } from '../../../../Common/CustomForm/CustomDynamicForm';
import moment from 'moment-timezone';

import { getWarehouseDataReducer } from '../../../../../../redux/reducers/reducerSlices/GetWarehouseDataReducer';
import { fetchDockListCommonFunc } from '../../../SmartScheduler/WarehouseMetaData/Forms/DocksMeta/Common/FetchDockList';
import { getWhMetaDataReducerSlice } from '../../../../../../redux/reducers/reducerSlices/WhMetaDataReducerSlice';
import { getUserSelector } from '../../../../../../redux/reducers/reducerSlices/UserReducer';
import { smartScheduleSelector } from '../../../../../../redux/reducers/reducerSlices/SmartScheduleReducer';
/**
 * This component is used to get the FS pay warehouse details and perform actions like create, edit, delete and select. 
 * And also this screen has search with warehouse name and pagination
 * @param {*} props 
 * @returns 
 */
const SPRODockMapping = (props) => {
    const { themeSelected = 'light-mode' } = props;
    const dispatch = useDispatch();
    const [searchStr, setSearchStr] = useState('');
    const divRef = useRef(null);
    const remoteConfig = useSelector(getRemoteConfigSelector);
    const { allConfigration } = remoteConfig;
    const { PaginationDefaultLimit } = allConfigration
    const warehouseData = useSelector(getWarehouseDataReducer);
        const whMetaReducer = useSelector(getWhMetaDataReducerSlice);
        const { whMetaDocksList} = whMetaReducer;
          const ss = useSelector(smartScheduleSelector);
          const { initateLoading,operationObj,
          dockMappingList } = ss;
    const [dockMappingArr, setDockMappingArr] = useState([]);
    const [selectedObj, setSelectedObj] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [showDeleteModel, setShowDeleteModel] = useState(false);
    const [currentItemIndex, setCurrentItemIndex] = useState('NA');
    const [currentDeleteIndex, setCurrentDeleteIndex] = useState('NA');

    const [editData, setEditData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [particularFieldValue, setParticularFieldValue] = useState(null);
    const [resetFormData, setResetFormData] = useState(0);
    const [isListLoading, setListLoading] = useState(false);
    const [selectedCreatedOnDate, setSelectedCreatedOnDate] = useState(null);

        const user = useSelector(getUserSelector);
        const { cu_id } = user;
    


    /**
     * Tabular array of headers to display
     */
    const titleDD = [
        { id: 'warehouseName', name: 'Warehouse Name' },
        { id: 'DockName', name: 'Dock Name' },
        { id: 'LoadType', name: 'LoadType' },
        { id: 'Vendor', name: 'Vendor' },
        { id: 'Buyer', name: 'Buyer' },
        { id: 'createdOn', name: 'Created On' },
        { id: 'updatedOn', name: 'Updated On' },
        { id: '', name: AppConstant.superUserAdmin.warehouseAdmin.warehouseTable.actionsColTitle },
    ]

    /**
     * To handle API response types
     */
    useEffect(() => {
        if (operationObj.type) {
            switch (operationObj.type) {
                case 'Delete':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.sproDockMapping.deleteSucess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.sproDockMapping.deleteFail);
                    }
                    break;
                case 'Edit':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.sproDockMapping.updateSucess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.sproDockMapping.updateFail);
                    }
                    break;
                case 'Create':
                    if (operationObj.status) {
                        handleApiResponse(AppConstant.notifications.dataAddedSuccess, AppConstant.sproDockMapping.insertSucess);
                    } else {
                        handleApiResponse(AppConstant.commonStrings.failure, AppConstant.sproDockMapping.insertFail);
                    }
                    break;
                case 'Fetch':
                    if (!operationObj.status) {
                        setListLoading(false);
                        setDockMappingArr([]);
                    }
                    break;
                default:
            }
        }
    }, [operationObj])


    /**
     * Used to get the company Group Details
     */
    useEffect(() => {
        setTimeout(()=>{
            // fetchData()
            dispatch({ type: sagaActions.SPRO_GET_WAREHOUSE_LIST, payload:  { crud_type: "S" }})
        },500)
       
    }, [])


     const fetchDockList = (warehouseID) => {
            const { apiParams, operationObj } = fetchDockListCommonFunc({ID:warehouseID});
            dispatch({ type: sagaActions.WAREHOUSE_META_DOCK_LIST_ACTION, payload: apiParams, operationObj: operationObj })
        }
    

    /**
     * Helper to handle to the API response
     * @param {*} result 
     * @param {*} message 
     */
    const handleApiResponse = (result, message) => {
        setListLoading(false);
        setCurrentItemIndex('NA')
        setCurrentDeleteIndex('NA')
        if (result === AppConstant.notifications.dataAddedSuccess) {
            showAlert(toast.TYPE.SUCCESS, message, themeSelected);
            closeCurrentpopup();

            fetchData();

        } else {
            showAlert(toast.TYPE.ERROR, message, themeSelected);

        }
        setLoading(false);
    }

    /**
   * used to filter and set the data to list if the search string is greater than 3 characters
   */
    useEffect(() => {
        if (searchStr.length > 3) {
            fetchData();
        } else if (searchStr === '') {
            fetchData();
        }
    }, [searchStr])

    /**
     * Used to set the fs warehouse data to the state variable
     */
    useEffect(() => {
        if (dockMappingList && dockMappingList.length) {
            setDockMappingArr(dockMappingList)
        } else {
            setDockMappingArr([])
        }

    }, [dockMappingList])



    const getWarehouseList = () => {
        const sortedWarehouse = warehouseData.data ? _.orderBy(warehouseData.data, ['WarehouseName'], ['asc']):[];
        return (
            sortedWarehouse && sortedWarehouse.length &&
            sortedWarehouse?.map((data, index) => {
                return (
                    <option key={data.ID} value={`${data.ID},${data.WarehouseName}`}>
                        {data.WarehouseName}
                    </option>
                );
            })
        );
    };

    const getDockList = () => {
        const sortedDocks = whMetaDocksList ? _.orderBy(whMetaDocksList, ['Name'], ['asc']):[];
        return (
            sortedDocks && sortedDocks.length &&
            sortedDocks?.map((data, index) => {
                return (
                    <option key={data.ID} value={`${data.ID},${data.Name}`}>
                        {data.Name}
                    </option>
                );
            })
        );
    };

    const getLoadType = () => {
        const loadTypeList = [
            {
            id:1,
            name:"INBOUND"
        },
        {
            id:2,
            name:"OUTBOUND"
        },
    ];
        return (
            loadTypeList && loadTypeList.length &&
            loadTypeList?.map((data, index) => {
                return (
                    <option key={data.id} value={`${data.name}`}>
                        {data.name}
                    </option>
                );
            })
        );
    };


    const getFormFieldData = (data, name) => {

        if (name === 'IDWarehouse' && data) {
            const id = data.split(",")[0]
            fetchDockList(id)
        }

    };

    /**
     * List of Items to show on the create and edit popup 
     */
    const formFieldList = [
        {
            name: "IDWarehouse",
            type: "select",
            size: "col-sm-6",
            position: 1,
            title:
                AppConstant.commonStrings.warehouse,
            formValidation: {
                required: true,
            },

            getSelectData: getWarehouseList,
        },
        {
            name: "IDDock",
            type: "select",
            size: "col-sm-6",
            position: 2,
            title:
                AppConstant.commonStrings.dockTitle,
            formValidation: {
                required: true,
            },
            getSelectData: getDockList,
        },
        {
            name: "Vendor",
            type: "text",
            size: "col-sm-6",
            position: 3,
            placeholder: '',
            title: AppConstant.poManagement.searchPOSection.vendorTitleStr,
            formValidation: {
                required: true,
            },
        },
        {
            name: "Buyer",
            type: "text",
            size: "col-sm-6",
            position: 4,
            title: AppConstant.smartScheduler.poSection.buyer,
            formValidation: {
                required: true,
            },
        },
        {
            name: "LoadType",
            type: "select",
            size: "col-sm-6",
            position: 4,
            title:
                AppConstant.poManagement.tableHeader.loadType,
            formValidation: {
                required: true,
            },
            getSelectData: getLoadType,
        },
    ]


    /**
     * This function used to get FS pay warehouse list data by connecting with API
     */
    const fetchData = (pageNo = 1, limit = PaginationDefaultLimit) => {
        setTimeout(() => {
            const operationObj = {
                type: '',
                status: ''
            }
            const params = {
                "CRUDTYPE": 'S'
            }

            operationObj.type = 'Fetch'

            dispatch({ type: sagaActions.SPRO_DOCK_MAPPING, payload: params, operationObj: operationObj });
        }, 0)
    }

    /**
     * Helper to delete
     * @param {*} data 
     * @param {*} index 
     */
    const deleteHandler = (data, index) => {
        setSelectedObj(data, index)
        setSelectedIndex(index)
        setShowDeleteModel(true)
    }

    /**
     * delete popup handler to delete the records based on the confirmation
     * @param {*} text 
     */
    const popupBtnHandler = (text) => {
        if (text === AppConstant.commonStrings.no) {
            setShowDeleteModel(false)
            setSelectedObj(null)
            setSelectedIndex(null)
        }
        else {
            setCurrentDeleteIndex(selectedIndex)
            const apiParams = {
                "ID": selectedObj.ID,
                "CRUDTYPE": 'D'
            }

            const operationObj = {
                type: 'Delete',
                status: ''
            }

            dispatch({ type: sagaActions.SPRO_DOCK_MAPPING, payload: apiParams, operationObj: operationObj })
        }
        setShowDeleteModel(false)
    }

    /**
     * Helper to show the delete conformation pop-up
     * @returns 
     */
    const showDeleteConfirmation = () => {
        const popupObj = {
            id: 'showDeleteConfirmation',
            modalLabel: 'showDeleteConfirmation',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: AppConstant.fsWarehouse.deleteTimeslotTitle,
            bodyText: `${AppConstant.commonStrings.areYouSure} ${AppConstant.sproDockMapping.deleteMappingStr} ?`,
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.no
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => { popupBtnHandler(text) }} closepopup={() => { setShowDeleteModel(false) }} themeSelected={themeSelected} showModal={showDeleteModel} />
    }

    /**
     * Helper function to get the submited data and forms it to create or update
     * @param {*} data 
     */
    const getSummitedFormData = (data) => {
        setLoading(true);
        let apiParams = {}
        const operationObj = {
            type: '',
            status: ''
        }
        if (Object.keys(editData).length) {
            const apiTempParams1 = {
                "ID": editData.ID,
                "CRUDTYPE": "U",
                "Vendor": data.Vendor,
                "Buyer": data.Buyer,
                "LoadType": data.LoadType,
                "IDDock": data.IDDock.split(",")[0],
                "IDWarehouse": data.IDWarehouse.split(",")[0],
                "WarehouseName": data.IDWarehouse.split(",")[1],
                "DockName": data.IDDock.split(",")[1],
                "CreatedOn": data.CreatedOn,
                "UpdatedOn": new Date().toISOString(),
                "CreatedBy": data.CreatedBy,
                "UpdatedBy": cu_id
            }
            operationObj.type = 'Edit'

            apiParams = {
                ...apiTempParams1
            }
        } else {
            const apiTempParams2 = {
                "ID": null,
                "CRUDTYPE": "I",
                "Vendor": data.Vendor,
                "Buyer": data.Buyer,
                "LoadType": data.LoadType,
                "IDDock": data.IDDock.split(",")[0],
                "IDWarehouse": data.IDWarehouse.split(",")[0],
                "WarehouseName": data.IDWarehouse.split(",")[1],
                "DockName": data.IDDock.split(",")[1],
                "CreatedOn": new Date().toISOString(),
                "UpdatedOn": new Date().toISOString(),
                "CreatedBy": cu_id,
                "UpdatedBy": cu_id
            }
            operationObj.type = 'Create'

            apiParams = {
                ...apiTempParams2
            }
        }
        dispatch({ type: sagaActions.SPRO_DOCK_MAPPING, payload: apiParams, operationObj: operationObj })
    };



    const closeCurrentpopup = () => {
        setShowModal(false);
    }

    /**
     * Helper function to show to popup to create the warehouse
     * @returns 
     */
    const showCreatePOPopup = () => {
        const popupObj = {
            id: 'createFsWarehouseFormPopup',
            modalLabel: 'createFsWarehouseFormPopup',
            showClose: true,
            showfooter: false,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'xl',
            title: !Object.keys(editData).length ? AppConstant.fsWarehouse.createFsWarehouse : AppConstant.fsWarehouse.editFsWarehouse,
            bodyText: createForm(),
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.comments.cancelCommentButtonTitle
                },
                btn2: {
                    show: true,
                    text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm.saveButtonTitle
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => () => ''} closepopup={closeCurrentpopup} themeSelected={themeSelected} showModal={showModal} />
    }

    const openCreateForm = () => {
        setShowModal(true);
        setEditData({});
    }
    const cancelbtndata = {
        show: true,
        text: AppConstant.comments.resetbutton,
    };
    const submitbtnData = {
        show: true,
        text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
            .saveButtonTitle,
    };

    /**
     * function to create form
     * @returns 
     */
    const createForm = () => {
        return (
            <CustomDynamicForm
                formFieldList={formFieldList}
                sort={true}
                cancelBtn={cancelbtndata}
                submitbtn={submitbtnData}
                themeSelected={themeSelected}
                getSummitedFormData={getSummitedFormData}
                getFormFieldData={getFormFieldData}
                editFormData={editData}
                loading={loading}
                resetFormData={resetFormData}
                setParticularFieldValue={particularFieldValue}
            />
        );
    };

    /**
     * Helper to get the data and populate on the screen while editing
     * @param {*} data 
     */
    const editClicked = (data) => {
        fetchDockList(data.IDWarehouse)

        let editData1 = {
            "ID": data.ID,
            "CRUDTYPE": "U",
            "Vendor": data.Vendor,
            "Buyer": data.Buyer,
            "LoadType": data.LoadType,
            "IDDock":`${data.IDDock},${data.DockName}`,
            "IDWarehouse": `${data.IDWarehouse},${data.WarehouseName}`,
            "WarehouseName": data.WarehouseName,
            "DockName": data.DockName,
            "CreatedOn": data.CreatedOn,
            "UpdatedOn": new Date().toISOString(),
            "CreatedBy": data.CreatedBy,
            "UpdatedBy": cu_id
        }
        setSelectedCreatedOnDate(data.createdOn);
        setEditData(editData1);
        setShowModal(true);
    }

    /**
     * Function to create action buttons
     * @param {*} groupObj 
     * @param {*} index 
     * @returns 
     */
    const actionsButton = (groupObj, index) => {
        return (
            <div>
                <span className='d-flex justify-content-center align-items-center gap-2' >
                    <button
                        className={'addButton'}
                        data-bs-toggle="modal"
                        data-bs-target={`#createFsWarehouseFormPopup`}
                        onClick={() => editClicked(groupObj)}
                    >
                        {AppConstant.commonStrings.edit}
                    </button>
                    <CustomButtonSS
                        disabled={false}
                        isLoading={currentDeleteIndex !== 'NA' && currentDeleteIndex === index ? true : false}
                        className={`no-border no-bg`}
                        onClick={() => { deleteHandler(groupObj, index) }}
                        isIcon={true}
                        iconClass={"fa-regular fa-trash-can fa-lg"}
                    />
                </span>
            </div>
        )
    }

    /**
     * function to show the formated list data on the screen
     * @param {*} data 
     * @returns 
     */
    const formatListDataDrillDown = (data) => {

        return data.map((el, index) => {
            return {
                0: el.WarehouseName || '-',
                1: el.DockName || '-',
                2: el.LoadType || '-',
                3: el.Vendor || '-',
                4: el.Buyer || '-',
                5: el.CreatedOn ? `${moment(el.CreatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.CreatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` : AppConstant.commonStrings.hypen,
                6: el.UpdatedOn ? `${moment(el.UpdatedOn).format(AppConstant.commonStrings.MM_DD_YYYY_dateFormat)}\n${moment(el.UpdatedOn).format(AppConstant.commonStrings.HH_mm_dateFormat)}` : AppConstant.commonStrings.hypen,
                7: actionsButton(el, index),
            }
        })
    }

    /**
     * This function is used to get the data and validate
     * @returns 
     */
    const getBodyData = () => {
        if (dockMappingArr && dockMappingArr) {
            return formatListDataDrillDown(dockMappingArr)
        }
        else {
            return []
        }
    }

    /**
     * Function used when page is changed in pagination then it fetches user rating deails
     * @param {*} pageNo 
     * @param {*} limit 
     */
    const pageChange = (pageNo, limit) => {
        fetchData(pageNo, limit)
    }

    return (
        <div className=''>
            <div className='d-flex justify-content-start my-2 mx-3'>
                <button
                    className={'addButton'}
                    data-bs-toggle="modal"
                    onClick={() => openCreateForm()}
                >
                    Add Warehouse Dock Mapping
                </button>

                {/* <div className='d-flex justify-content-end align-items-end'>
                    <div className='ms-2 w-100'>
                        <WarehouseSearch
                            placeholder={AppConstant.poManagement.searchPOSection.searchTitleWarehouseStr}
                            inputValue={searchStr}
                            cancelSearch={() => setSearchStr('')}
                            onChangeHandler={(text) => setSearchStr(text)} />
                    </div>

                </div> */}

            </div>
            <div className='fswarehouseContainer' ref={divRef}>
                <DrilldownTableSS
                    key={Math.random()}
                    themeSelected={themeSelected}
                    bodyData={getBodyData()}
                    titleData={titleDD}
                    showCollapse={false}
                    showInput={false}
                    showSort={true}
                    hasCollapsableContent={false}
                    collapsableData={[]}
                    accordionPrimaryIndex={1}
                    drillDownReport={dockMappingArr}
                    initiateDrillDownReport={initateLoading}
                    loaderArray={8}
                    sortingAction={sagaActions.SORT_SS_USER_TABLE}
                    subRoot={{ pathName: 'dockMappingList' }}
                    showUTCTime={true}
                />
                {showDeleteConfirmation()}

            </div>
            {showCreatePOPopup()}

            {!_.isEmpty(dockMappingArr) && dockMappingArr?.data?.Items?.length ?
                <div className='f-14'>
                    <CustomPaginationSS
                        pageNo={dockMappingArr.data.currentPage}
                        pageSize={dockMappingArr.data.itemsPerPage}
                        first={(Number(dockMappingArr.data.currentPage) === 1) ? true : false}
                        last={Math.ceil(dockMappingArr.data.totalCount / Number(dockMappingArr.data.itemsPerPage)) === (Number(dockMappingArr.data.currentPage)) ? true : false}
                        totalElements={dockMappingArr.data.totalCount}
                        totalPages={dockMappingArr.data.totalPages}
                        pageChange={(pageNo, limit) => { pageChange(pageNo, limit) }}
                    />
                </div> : ""
            }

        </div>
    )
}

export default SPRODockMapping